module.exports = __webpack_public_path__ + "font_genshin.cfd8c1fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/font_genshin.png
// module id = rU2z
// module chunks = 0